import {useQuery} from "@tanstack/react-query"
import {API} from "config"

const useBestReferral = () => useQuery({
    queryKey: [`best-referral`], queryFn: async () => {
        const callback = await API.get(`/best-referral`)
        return callback?.data
    },
    staleTime: 1000 * 60,
    gcTime: 1000 * 60 * 60 * 60 * 24,
    refetchInterval: 1000 * 60 * 20
})

export default useBestReferral